const Footer = () => {
    return ( 
        <div className="flex flex-col items-center justify-center py-10 md:text-xl font-rubik">
            <p className="text-sm md:text-md">&copy;2022, Collinson Oga - <code>codeBro</code></p>
            <p className="text-sm">Made with ❤love, ✨React and 🔥Tailwind</p>
        </div>
     );
}
 
export default Footer;